import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PatchQuestion } from '@styled-icons/bootstrap/PatchQuestion';
import { ThemeTypography } from 'DesignSystem';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import React, { FC, ReactNode } from 'react';
import { Booleanish, Tbooleanish } from 'types/booleanish.types';

interface IEmptyStateProps {
  message?: string;
  additionalInfo?: string;
  center?: boolean;
  className?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  Icon?: ReactNode;
}

const Container = styled('div')<{ center: Tbooleanish }>(({ theme, center }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontWeight: 500,

  ...(center === 'true'
    ? {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate3d(-50%, -50%, 0)',
      }
    : {}),
}));

const EmptyState: FC<IEmptyStateProps> = ({
  message,
  center = true,
  additionalInfo,
  className,
  action,
  Icon,
}) => {
  if (!message) message = 'There is nothing here yet.';

  return (
    <Container center={Booleanish(center)} className={className}>
      <Box mb={1}>{Icon ? Icon : <PatchQuestion size={24} />}</Box>
      <ThemeTypography variant="BODY_LARGER_BOLD" color="GRAY_60">
        {message}
      </ThemeTypography>
      {additionalInfo && (
        <ThemeTypography mt={2} variant="BODY_LARGE" color="GRAY_60">
          {additionalInfo}
        </ThemeTypography>
      )}
      {action && (
        <Box mt={2}>
          <ThemeButton size="medium" onClick={action.onClick} color="BLUE_ICE">
            {action.label}
          </ThemeButton>
        </Box>
      )}
    </Container>
  );
};

export default EmptyState;
